import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import firebase from "firebase/app";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Vuelidate from "vuelidate";
import "firebase/functions";
import "firebase/auth";
import "firebase/database";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import VueAxios from "vue-axios";
import onlyInt from "vue-input-only-number";
//import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(VueSweetalert2);
Vue.use(Vuelidate);
Vue.use(DatePicker);
Vue.use(VueAxios, axios);
Vue.use(onlyInt);

firebase.initializeApp({
  apiKey: "AIzaSyDut7XXNoiRcag3wpDRdVfk9uDfwdxalys",
  authDomain: "blink-fb.firebaseapp.com",
  databaseURL: "https://blink-fb.firebaseio.com",
  projectId: "blink-fb",
  storageBucket: "blink-fb.appspot.com",
  messagingSenderId: "607421696609",
  appId: "1:607421696609:web:690ad93e2e666500f03820",
  measurementId: "G-5HG46H8624"
});

router.beforeEach((to, from, next) => {
  // Ensure we checked auth before each page load.
  //Promise.all([store.dispatch("authAction")]).then(next);
  next();
  // reset config to initial state
  //store.dispatch(RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

let app;

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      i18n,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  }
});
